import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import "./Footer.scss";
import logo from "./../../img/logos/mfly_white.png";

const quickLinks = [
  { name: "Home", path: "/" },
  { name: "Members", path: "/members" },
  { name: "Sponsors", path: "/sponsors" },
  { name: "Get Involved", path: "/get-involved" },
];

const aircraft = [
    { name: "Hi-Lift", path: "/aircraft/hi-lift" },
    { name: "Advanced", path: "/aircraft/advanced" },
    { name: "Auton", path: "/aircraft/auton" },
    { name: "History", path: "/aircraft/history" },
]

const socials = [
  {
    icon: faFacebook,
    url: "https://www.facebook.com/UmichMFLY/",
    name: "Facebook",
  },
  {
    icon: faInstagram,
    url: "https://www.instagram.com/mfly_umich/",
    name: "Instagram",
  },
  {
    icon: faLinkedin,
    url: "https://www.linkedin.com/company/m-fly-aero-design/",
    name: "LinkedIn",
  },
  {
    icon: faTwitter,
    url: "https://twitter.com/UofM_MFly",
    name: "Twitter",
  },
];

function Footer() {
  const currentYear = new Date().getFullYear();
  const scrollToTop = () => window.scrollTo(0, 0);

  return (
    <footer className="site-footer">
      <div className="site-footer__content">
        <div className="site-footer__brand">
          <Link
            to="/"
            className="site-footer__logo-link"
            aria-label="M-Fly home"
            onClick={scrollToTop}
          >
            <img src={logo} alt="M-Fly logo" className="site-footer__logo" />
          </Link>
          <p className="site-footer__text">University of Michigan</p>
        </div>

        <div className="site-footer__section">
          <h4 className="site-footer__heading">Quick Links</h4>
          <nav className="site-footer__links" aria-label="Footer quick links">
            {quickLinks.map(({ name, path }) => (
              <Link key={path} to={path} className="site-footer__link" onClick={scrollToTop}>
                {name}
              </Link>
            ))}
          </nav>
        </div>

        <div className="site-footer__section">
          <h4 className="site-footer__heading">Aircraft</h4>
          <nav className="site-footer__links" aria-label="Footer aircraft links">
            {aircraft.map(({ name, path }) => (
              <Link key={path} to={path} className="site-footer__link" onClick={scrollToTop}>
                {name}
              </Link>
            ))}
          </nav>
        </div>

        <div className="site-footer__section">
          <h4 className="site-footer__heading">Connect</h4>
          <div className="site-footer__socials">
            {socials.map(({ url, icon, name }) => (
              <a
                key={name}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="site-footer__social"
                aria-label={name}
              >
                <FontAwesomeIcon icon={icon} size="lg" />
              </a>
            ))}
          </div>
          <a href="mailto:mfly@umich.edu" className="site-footer__link">
            mfly@umich.edu
          </a>
        </div>
      </div>

      <div className="site-footer__bottom">
        <p className="site-footer__copyright">© {currentYear} M-Fly. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
